import {$t} from '@bitstillery/common/app'

import {format_iso_to_date} from './format'
import type {PortalOfferItem} from '@bitstillery/common/api/fact2server'

interface SpecsItem {
    bottle_volume?: string | number | null | undefined
    bottle_alcohol_percentage?: string | number | null | undefined
    bottle_refill_status?: string | null | undefined
    case_number_of_bottles?: number | string | null | undefined
    case_gift_box_type?: string | number | null | undefined
    case_customs_status?: string | null | undefined
    case_tax_label?: string | number | null | undefined
    product_category_name?: string | null | undefined
}

/** The spec segments as a list (number of bottles, volume, ABV, gift box, refill, customs, tax, category),
 *  falsy entries dropped. Consumers that want to style the segments individually (e.g. the product card
 *  renders them with muted separators) use this; `to_specs` joins them into the legacy ` / ` string. */
export function to_specs_parts(item: SpecsItem): string[] {
    return [
        item.case_number_of_bottles,
        item.bottle_volume ? `${Number(item.bottle_volume).toFixed(1)} cl` : '',
        `${Number(item.bottle_alcohol_percentage).toFixed(1)}${$t('unit.percentage')}`,
        item.case_gift_box_type,
        item.bottle_refill_status ? item.bottle_refill_status.toUpperCase() : '',
        item.case_customs_status,
        item.case_tax_label,
        item.product_category_name,
    ]
        .filter((i): i is string | number => Boolean(i))
        .map(String)
}

export function to_specs(item: SpecsItem) {
    return to_specs_parts(item).join(' / ')
}

export function to_tags(
    offer_item: Pick<
        PortalOfferItem,
        'case_tax_label' | 'item_best_before_date' | 'item_damages' | 'item_general_tags' | 'item_pack_size' | 'item_packaging'
    >,
) {
    let bbd = ''
    if (offer_item.item_best_before_date) {
        bbd = `BBD ${format_iso_to_date(offer_item.item_best_before_date)}`
    }
    const tags_line = [
        [offer_item.case_tax_label],
        [offer_item.item_damages],
        [offer_item.item_general_tags],
        [offer_item.item_pack_size],
        [offer_item.item_packaging],
        [bbd, 'bbd'],
    ]
    return tags_line.filter((i) => i[0]?.length).join(' / ')
}
